<template>
  <main class="statement-page">
    <section class="statement-hero">
      <header class="statement-nav">
        <button type="button" aria-label="Back" @click="back"><van-icon name="arrow-left" /></button>
        <h1>personal statement</h1>
        <span></span>
      </header>
      <div class="statement-total">
        <p>task amount(Points)</p>
        <strong>{{ amount }}</strong>
        <i></i>
        <small>Profit Calculation Formula: Winning Amount - Task Amount</small>
      </div>
    </section>

    <section class="statement-details">
      <div v-for="item in details" :key="item.label" class="statement-details__item">
        <strong>{{ item.value }}</strong>
        <span>{{ item.label }}</span>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    return {
      win_money:0,
      personalreport:{}
    };
  },
  computed: {
    amount() {
      return Number(this.win_money || 0).toFixed(2);
    },
    details() {
      return [
        { label: "task amount", value: this.valueOf("play_money") },
        { label: "Recharge amount", value: this.valueOf("recharge") },
        { label: "Amount", value: this.valueOf("withdrawal") },
        { label: "winning amount", value: this.valueOf("win_money") }
      ];
    }
  },
  methods: {
    valueOf(key) {
      const value = Number(this.personalreport[key] || 0);
      return Number.isFinite(value) ? value.toFixed(2) : "0.00";
    },
    back(){
      return window.history.back();
    },
    getPersonalreport(){
      this.$http({
        method: 'get',
        url: 'user_get_personalreport'
      }).then(res=>{
        if(res.code === 200){
          this.personalreport = res.data;
          this.win_money = this.personalreport.win_money - this.personalreport.play_money;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getPersonalreport();
    }
  }
};
</script>

<style scoped>
.statement-page {
  min-height: 100vh;
  background: #f4f4f7;
  color: #fff;
}

.statement-hero {
  height: 12.7rem;
  background: linear-gradient(105deg, #713d96 0%, #b496ce 100%);
}

.statement-nav {
  height: 3.22rem;
  display: grid;
  grid-template-columns: 3rem 1fr 3rem;
  align-items: center;
}

.statement-nav button {
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 1.34rem;
}

.statement-nav h1 {
  margin: 0;
  color: #fff;
  font-size: 1.08rem;
  font-weight: 700;
  text-align: center;
}

.statement-total {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.28rem;
}

.statement-total p {
  margin: 0;
  color: #f4edf8;
  font-size: 0.9rem;
}

.statement-total strong {
  margin-top: 0.78rem;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1;
}

.statement-total i {
  width: 4.15rem;
  height: 0.06rem;
  margin: 0.18rem 0 1.05rem;
  background: #fff;
}

.statement-total small {
  align-self: flex-start;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  margin:0 auto;
}

.statement-details {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2.6rem 0;
  padding: 2.35rem 0.7rem 0;
  color: #96909f;
}

.statement-details__item {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  min-width: 0;
  text-align: center;
}

.statement-details__item strong {
  order: 0;
  min-height: 0.7rem;
  color: #8954bd;
  font-size: 1.25rem;
  font-weight: 500;
}

.statement-details__item span {
  order: 1;
  color: #96909f;
  font-size: 0.9rem;
  white-space: nowrap;
}
</style>
